import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

export function getEntries<T>(obj: T): Entries<T> {
  return Object.entries(obj as { [s: string]: T }) as unknown as Entries<T>;
}

export const toLondonDateString = (date: Date | dayjs.Dayjs) => {
  return dayjs(date).tz('Europe/London').format('YYYY-MM-DD HH:mm:ss');
};

export const getTimeZone = () => dayjs.tz.guess();

export function dedupeArray<T, K extends keyof T>(items: T[], key: K): T[] {
  const seen = new Set<T[K]>();

  return items.filter(item => {
    const keyValue = item[key];
    if (seen.has(keyValue)) {
      return false;
    }
    seen.add(keyValue);
    return true;
  });
}
